import { useIsWishlist } from '@hooks/useIsWishlist';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { useCallback } from 'react';
import { addProductInWishlist, deleteProductFromWishlist, selectWishList } from '@redux/slices/ProductManagement';

export interface useWishlistReturn {
  count: number;
  isFlag: boolean;
  handlerAdd: () => void;
  handlerDelete: () => void;
}

export const useWishlist = (productId: number, part: number, regionId: number): useWishlistReturn => {
  const dispatch = useAppDispatch();
  const wishList = useAppSelector(selectWishList);
  const isFlag = useIsWishlist(productId);
  const count = wishList.length;
  const handlerAdd = useCallback(() => {
    dispatch(addProductInWishlist({ id: productId, part, regionId }));
  }, [productId, part, regionId]);

  const handlerDelete = useCallback(() => {
    dispatch(deleteProductFromWishlist({ id: productId, regionId }));
  }, [productId, part, regionId]);
  return { count, isFlag, handlerAdd, handlerDelete };
};
